module.exports = __webpack_public_path__ + "static/media/b-sci-major-17_LR.2a547fc7.jpg";